export class Environment {
    static apiUrl: string = 'https://freezer.gethex.com.pe/api';
  // static apiUrl: string = 'http://localhost:7066/api/';
  
  }